module.exports = __webpack_public_path__ + "static/media/lpi.members.logo.black.4310407c.svg";